import React, { useState, useEffect } from "react";
import Header from "../include/header";
import Footer from "../include/footer";
import MasterLeftPanel from "../include/MasterLeftPanel";
import Global from "../../APIConfig";
import axios from "axios";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Link, useNavigate, useParams } from "react-router-dom";
import AuthUser from "../../AuthUser";
import MainLoader from "../Loaders/MainLoader";
import ListLoader from "../Loaders/ListLoader";

function ImportLocation() {
    const navigate = useNavigate();
    const { headers1, headers2, logout } = AuthUser();
    const [Loading, setLoading] = useState(false);
    const [Subloading, setSubloading] = useState(true);
    const [file, setFile] = useState(null);
    useEffect(() => {
    }, []);

    const handleDownload = () => {
        const link = document.createElement('a');
        link.href = '/assets/countrystatecity.csv'; // Path to your file
        link.download = 'countrystatecity.csv'; // Name of the file to be downloaded
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      };

      const handleFileChange = (e) => {
        setFile(e.target.files[0]);
      };
    
      const handleUpload = () => {
        setLoading(true);
        const formData = new FormData();
        formData.append('file', file);
        axios.post(Global.baseUrl + 'uploadpincountrystatecity', formData, {
            headers: headers2,
          })
          .then((response) => {
            toast.success('File uploaded successfully');
            setLoading(false);
          })
          .catch((error) => {
            if(error.response.status==401){
                toast.error(error.response.statusText);
                logout();
                navigate('/');
                window.location.reload();
            }
            setLoading(false);
          });
      };

    return (
        <>
            <MasterLeftPanel />
            <main className='home-section'>
                <Header />
                <ToastContainer />
                {Loading == true ? <MainLoader /> :
                    <>
                        <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                            <div className="d-block mb-4 mb-md-0">
                                <nav aria-label="breadcrumb" className="d-none d-md-inline-block">
                                    <ol className="breadcrumb breadcrumb-dark breadcrumb-transparent">
                                        <li className="breadcrumb-item">
                                            <a href="/Admin-Dash">
                                                <i className="bx bx-home text-primary-400 fs-6"></i>
                                            </a>
                                        </li>
                                        <li className="breadcrumb-item active" aria-current="page">Import Country/State/City</li>
                                    </ol>
                                </nav>
                                <div className="d-flex">
                                    <div className="">
                                        <button className="btn btn_nav btn-sm" type="button" onClick={() => navigate(-1)}>
                                            <i className="bx bx-arrow-back "></i>
                                        </button>
                                    </div>
                                    <div className="ps-2 ">
                                        <h2 className="h4">Import Country/State/City</h2>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-12 col-md">
                                <div className="custom_nav_data_table">

                                </div>
                            </div>


                        </div>

                        <section className="data_table">
                            <div className="card card-body border-0 shadow table-wrapper table-responsive ">
                                <table className="table table-hover">
                                    <tbody>
                                        <tr>
                                            <td>
                                                <span className="bold">NOTE: </span>
                                                <span className="fw-normal text-capitalize">Only xls or xlsx file must be uploaded. Use sequence of column table in excel as example.xlsx</span></td>
                                        </tr>
                                        <tr>
                                            <td>
                                               <span className="bold">Format for excel sheet: </span>
                                                <span className="fw-normal text-capitalize">Postal code | Country  | State | City</span>
                                            </td>
                                        </tr>
                                        {/* <tr>
                                            <td>
                                               <span className="bold">Postal code: </span><span className="fw-normal text-capitalize">Pincode must be Numeric value ie. 1234567890.Don't use special character or coma.</span></td>
                                        </tr> */}
                                        <tr>
                                            <td>
                                               <span className="bold">Country: </span><span className="fw-normal text-capitalize">Do not use special character or coma or bracket. ie. Warangal (Kazipet-Hanmakonda) this in not valid and could not upload.</span></td>
                                        </tr>
                                        <tr>
                                            <td>
                                               <span className="bold"> State: </span><span className="fw-normal text-capitalize">Do not use special character or coma or bracket. ie. Warangal (Kazipet-Hanmakonda) this in not valid and could not upload.</span></td>
                                        </tr>
                                        <tr>
                                            <td><span className="bold">City: </span><span className="fw-normal text-capitalize">Do not use special character or coma or bracket. ie. Warangal (Kazipet-Hanmakonda) this in not valid and could not upload.</span></td>
                                        </tr>
                                        <tr>

                                        </tr>
                                        <tr>

                                        </tr>
                                        <tr>
                                            <td align="center"><a onClick={handleDownload}><img src="https://en.grk-co.com/assets/images/images/excel_download.png" title="Download Excel File" /></a> (folder images) for download example file.
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>  <input type="file" onChange={handleFileChange} accept=".csv,.xlsx,.xls" /></td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <button className="btn btn-primary" onClick={handleUpload}>Upload</button>
                                            </td>
                                        </tr>
                                </tbody>
                            </table>
                        </div>
                    </section>
            </>
            }
            <Footer />
        </main >
        </>
        );
}
export default ImportLocation;